import { render, staticRenderFns } from "./multiple-textfield.vue?vue&type=template&id=8bc8ba8c&"
import script from "./multiple-textfield.vue?vue&type=script&lang=js&"
export * from "./multiple-textfield.vue?vue&type=script&lang=js&"
import style0 from "./multiple-textfield.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
